import { styled } from '@mui/material/styles';
import { Table } from '@components/Table';

export const InsightsContainer = styled('section')({
    backgroundColor: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: '16px',
    borderRadius: '8px',
    '@media (max-width: 1024px)': {
        margin: '0 -16px',
        height: 'calc(var(--100vh) - 173px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        borderRadius: 0,
    },
    '@media print': {
        height: 'auto',
    },
});

export const PairedRow = styled('div')({
    display: 'grid',
    gridTemplateColumns: '1.4fr 1fr',
    gap: 16,
    '@media (max-width: 1024px)': {
        gridTemplateColumns: '1fr',
    },
});

export const CloudBox = styled('div')({
    backgroundColor: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 240,
    '@media (max-width: 1024px)': {
        height: 400,
    },
});

export const StyledTable = styled(Table)({
    '& .MuiTableBody-root .MuiTableCell-root:last-child': {
        width: 150,
    },
});

// INFO: 1 - positive, 0 - neutral, 2 - negative
const KEYWORD_COLOR_MAP = {
    1: '#4CC474',
    0: '#FFCE4D',
    2: '#FF5853',
};

export const SentimentWrapper = styled('div')({
    width: 168,
    display: 'flex',
    height: 8,
});

export const SentimentPiece = styled('div', {
    shouldForwardProp: prop => prop !== 'type' && prop !== 'percentage',
})(({ type, percentage }) => ({
    backgroundColor: KEYWORD_COLOR_MAP[type],
    width: `${percentage}%`,
}));

export const InsightsCard = styled('div')({
    backgroundColor: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    padding: 16,
});

export const CategoryRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    '&:last-child': {
        borderBottom: 'none',
    },
    '& .view-reviews-btn': {
        visibility: 'hidden',
    },
    '&:hover .view-reviews-btn': {
        visibility: 'visible',
    },
});
